import { ApiClient } from '../utils/apiClient';
import { authService } from './authService';
import { logger } from '../utils/logger';

const DEFAULT_INTERVAL_MS = 30 * 60 * 1000;

class SessionHeartbeatService {
  private timer: ReturnType<typeof setInterval> | null = null;

  start(intervalMs: number = DEFAULT_INTERVAL_MS): void {
    this.stop();

    if (!authService.isAuthenticated()) {
      return;
    }

    this.timer = setInterval(() => {
      void this.sendHeartbeat();
    }, intervalMs);

    logger.debug('JWT 会话心跳已启动', { intervalMs });
  }

  stop(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
      logger.debug('JWT 会话心跳已停止');
    }
  }

  private async sendHeartbeat(): Promise<void> {
    if (!authService.isAuthenticated()) {
      this.stop();
      return;
    }

    try {
      await ApiClient.post(
        '/users/session/heartbeat',
        null,
        { skip401Handler: true }
      );
      logger.debug('JWT 会话心跳成功');
    } catch (error) {
      const status = (error as { status?: number }).status;
      const message = error instanceof Error ? error.message : undefined;

      if (status === 401) {
        this.stop();
        await authService.handleUnauthorized(message);
        return;
      }

      logger.warn('JWT 会话心跳失败（非 401，将继续重试）:', error);
    }
  }
}

export const sessionHeartbeatService = new SessionHeartbeatService();
